import { LOGIN_TOKEN, PARCEIRO_DATA, SSE_VALUE, SSE_VALUEEnd } from 'domain/types/authentication/authentication';
import { AuthenticationService } from 'domain/services/authentication/authenticationService'
import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils';
import { _UserData, UserDataBaseEnum } from '../../../infra/storage/localStorage';
import { UsuarioResponse } from 'domain/types/usuario/usuarioResponse';
import { AppThunk } from '../../../utils/reducerUtil';
import { ParceiroService } from 'domain/services/parceiro/parceiroService';
import { Get, Post, SSEOptions, StreamMessage } from 'domain/infra/data/api';
import { GetUsuarioSistemaPerfil } from '../../usuarioSistemaPerfil/action/usuarioSistemaPerfilAction';
import { USUARIO_SISTEMA_PERFIL_GET } from 'domain/types/usuarioSistemaPerfil/usuarioSistemaPerfil';
import { UsuarioSistemaPerfilResponse } from 'domain/types/usuarioSistemaPerfil/usuarioSistemaPerfilResponse';
// import { StateType } from 'domain/types/base/base';


const _AuthenticationService = new AuthenticationService();
const _ParceiroService = new ParceiroService();

export function ResetAuthState(): AppThunk {
	return async (dispatch) => {
		dispatch({ payload: false, type: LOGIN_TOKEN });
	};
}

export function ParceiroByUrl(url: string): AppThunk {
	return async (dispatch) => {
		const asyncResponse = await _ParceiroService.GetByUrl(url);

		if (ResponseValid(asyncResponse)) {

			dispatch({
				payload: asyncResponse,
				type: PARCEIRO_DATA
			});

		}
	};
}

export function LoginByToken(token?: string | null, reportError: boolean = true): AppThunk {
	return async (dispatch) => {
		const _userData = _UserData;

		if (token == null || token == "") {
			_userData.Clear();
			dispatch({
				payload: false,
				type: LOGIN_TOKEN
			});
			if (reportError) dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.ERROR));
			return;
		}

		dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.LOADING));

		const asyncResponse = await _AuthenticationService.LoginByToken(token);

		if (ResponseValid(asyncResponse)) {

			const Usuario = asyncResponse as UsuarioResponse;
			_userData.Register(Usuario);
			dispatch(GetUsuarioSistemaPerfil(Usuario.UsuarioID));

			dispatch({
				payload: true,
				type: LOGIN_TOKEN
			});

		} else {
			_userData.LogOut();

			dispatch({
				payload: false,
				type: LOGIN_TOKEN
			});

			if (reportError) dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.ERROR, (asyncResponse as Error).message));
		}
	};
}

export function CheckHasLogin(logOut: boolean): AppThunk {
	return async (dispatch) => {
		function handleOut() {
			_UserData.Clear();

			dispatch({
				payload: false,
				type: LOGIN_TOKEN
			});
		}

		if (logOut) {
			handleOut();
			return null;
		}

		//Ainda não implementado corretamente
		// const manterConectado = _UserData.Get<boolean>(UserDataBaseEnum.ManterConectado);
		// if(manterConectado == false){
		//     handleOut();
		//     return
		// }

		const token = _UserData.Get<string>(UserDataBaseEnum.Token);
		if (token != null) {
			dispatch({
				payload: true,
				type: LOGIN_TOKEN
			});
			LoginByToken(token);
		}
	};
}


function decodeJwtPayloadRaw(token: string): Record<string, unknown> | null {
	try {
		const base64Url = token.split('.')[1]
		if (!base64Url) return null
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		)
		return JSON.parse(jsonPayload)
	} catch {
		return null
	}
}

export function LoginByAccessToken(token: string, validatorUrl: string): AppThunk {
	return async (dispatch) => {
		const _userData = _UserData;

		dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.LOADING));

		const isValid = await Post<{ token: string }, boolean>(validatorUrl, { token });

		if (isValid instanceof Error || isValid !== true) {
			_userData.Clear();
			dispatch({ payload: false, type: LOGIN_TOKEN });
			return;
		}

		const payload = decodeJwtPayloadRaw(token);
		const usuarioID = payload ? Number(payload.UsuarioID) : 0;

		if (!usuarioID) {
			_userData.Clear();
			dispatch({ payload: false, type: LOGIN_TOKEN });
			return;
		}

		const usuario: UsuarioResponse = {
			UsuarioID: usuarioID,
			Token: token,
			NomeCompleto: (payload!.NomeCompleto as string) ?? '',
			NomeExibicao: (payload!.NomeExibicao as string) ?? '',
			UsuarioAcesso: (payload!.UsuarioAcesso as string) ?? '',
			DataNascimento: null as unknown as Date,
			TelefoneCelular: (payload!.TelefoneCelular as string) ?? '',
			TelefoneFixo: '',
			Email: (payload!.Email as string) ?? '',
			EmpresaID: Number(payload!.EmpresaID) || 0,
			ImagemUrl: (payload!.ImagemUrl as string) ?? '',
			ChavePix: '',
			CPF: '',
			TokenPushNotification: '',
			ManterConectado: false,
		};

		_userData.Register(usuario);

		const campanhaID = payload!.CampanhaID;
		if (campanhaID) {
			_userData.SetOtherData('CampanhaID', String(campanhaID));
		}

		const apiBaseUrl = validatorUrl.replace(/\/oauth2\/validate$/, '');
		const perfilResponse = await Get<UsuarioSistemaPerfilResponse[]>(`${apiBaseUrl}/UsuarioSistemaPerfil/GetUsuarioSistemaPerfil?usuarioId=${usuarioID}`);
		if (ResponseValid(perfilResponse, false)) {
			dispatch({
				payload: perfilResponse,
				type: USUARIO_SISTEMA_PERFIL_GET
			});
		}

		dispatch({ payload: true, type: LOGIN_TOKEN });
	};
}

//TODO REMOVER
// eslint-disable-next-line no-unused-vars
export function TestSSE(onError: (event: Event) => void, onOpen: () => void, onMessage: (data: StreamMessage<number>) => void): AppThunk {
	return async (/*dispatch*/) => {

		const options: SSEOptions<number> = {
			dispatchName: SSE_VALUE,
			onError: onError,
			onMessage: onMessage,
			onOpen: onOpen,
		}

		//options?.dispatchName && dispatch(DispatchLoading(SSE_VALUEEnd, DispatchType.LOADING, "SSE", StateType.Master))

		/*const asyncResponse =*/ await _AuthenticationService.TestSSE<string, number>("aa", SSE_VALUEEnd, options)

		/*if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: SSE_VALUEEnd
			});
			return asyncResponse;
		}*/

	}
}
